/* eslint-disable no-useless-escape */
export class Validation {
    public static isEmail(email: string | undefined | null): boolean {
        if (email === undefined || email == null) return false;

        if (
            !/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                email
            )
        )
            return false;

        const validUsernameChars = "abcdefghijklmnopqrstuvwxyzäöüABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÜ0123456789-._@+";
        for (let i = 0; i < email.length; i++) {
            if (!validUsernameChars.includes(email.charAt(i))) return false;
        }

        return true;
    }

    public static isMultiEmail(emails: string): boolean {
        if (emails === undefined || emails == null) return false;

        const emailSplits = emails.split(";");
        for (const i in emailSplits) {
            const s = emailSplits[i];
            if (!Validation.isEmail(s.trim())) return false;
        }

        return true;
    }

    public static isUrl(userInput): boolean {
        if (userInput === undefined || userInput == null) return false;

        const res = userInput.match(
            /^(?:(?:(?:https?|ftp):)?\/\/)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i
        );
        if (res == null) return false;
        else return true;
    }

    public static isInternationalPhoneNumber(userInput: string): boolean {
        if (userInput === undefined || userInput == null) return false;

        if (userInput[0] !== "+") return false;

        return true;
    }

    public static isNumeric(str: string): boolean {
        if (str === undefined || str == null) return false;

        if (str.match(/^\d+$/)) return true;

        return false;
    }

    public static isPassword(str: string): boolean {
        if (str === undefined || str == null) return false;

        if (str.length < 8) return false;

        if (!/[A-Z]/.test(str)) return false;

        if (!/[0-9]/.test(str)) return false;

        if (!/[a-z]/.test(str)) return false;

        return true;
    }

    public static isZip(str: string): boolean {
        if (str === undefined || str == null) return false;

        if (str.length < 4) return false;

        // if (!Validation.isNumeric(str))
        //     return false;

        return true;
    }

    public static isStreetAndNumber(str: string): boolean {
        if (str === undefined || str == null) return false;

        //contains at least one char
        if (!RegExp("[a-zA-Z]+").test(str)) return false;

        //contains at least one digit
        if (!RegExp("[0-9]+").test(str)) return false;

        return true;
    }

    public static isLatLng(str: string | number): boolean {
        if (str === undefined || str == null) return false;

        return true;
    }
}
